export const achievementData = {
    bio: 'Focused on delivery, modernization, and steady growth.',
    achievements: [
        {
            id: 1,
            title: 'Scrum Master I',
            details: 'Certified Scrum.org PSM-I professional with Agile delivery experience.',
            date: 'Sept 2019',
            field: 'Agile',
            image: 'https://scrumorg-website-prod.s3.amazonaws.com/drupal/inline-images/2022-09/asset_44psmi_0.png',
        },
        {
            id: 2,
            title: 'Full Stack Certification',
            details: 'Completed training in Angular, Spring Boot, and microservices.',
            date: '2020–2023',
            field: 'Learning',
            image: '',
        },
        {
            id: 3,
            title: 'Cloud Modernization',
            details: 'Delivered migration work across AWS and Azure.',
            date: '2023–Present',
            field: 'Cloud',
            image: '',
        }
    ]
}